import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Tabs from '../../../components/Tab/Tab';
import SettingCustomColor from './SettingCustomColor';
import SettingCustomName from './SettingCustomName';
import Loader from '../../../components/Loader/Loader';
import SettingCustomOther from './SettingCustomOther';
import SettingCustomTimerCTRL from './SettingCustomTimerCTRL';

const SettingCustom = ({
    getSettingCustomColor,
    updateSettingCustomColor,
    clearGetSettingColor,
    clearUpdateSettingColor,
    isLoading,
    customColor,
    updateCustomColor,
    getSettingCustomText,
    clearGetSettingCustomText,
    updateSettingCustomText,
    clearUpdateSettingCustomText,
    customText,
    updateCustomText,
    
    getSettingCustomComment,
    clearGetSettingCustomComment,
    updateSettingCustomComment,
    clearUpdateSettingCustomComment,
    customComment,
    updateCustomComment,
    updateStatusComment,

    getSettingCustomTimerctrl,
    clearGetSettingCustomTimerctrl,
    updateSettingCustomTimerctrl,
    clearUpdateSettingCustomTimerctrl,
    customTimerctrl,
    updateCustomTimerctrl,
    updateStatusTimerctrl,

    eventInfo,
}) => {
    const [currentTab, setCurrentTab] = useState(0);

    const handleChangeTab = (val) => {
        setCurrentTab(val);
    };
    return (
        <>
            <Loader isLoading={isLoading} />
            <Tabs
                headers={[
                    <FormattedMessage id="adminSettingCustom.customColor" />,
                    <FormattedMessage id="adminSettingCustom.customName" />,
                    <FormattedMessage id="adminSettingCustom.customComment" />,
                    <FormattedMessage id="adminSettingCustom.customTimerctrl" />,
                ]}
                onChangeTab={handleChangeTab}
            />
            {currentTab === 0 && (
                <SettingCustomColor
                    getSettingCustomColor={getSettingCustomColor}
                    updateSettingCustomColor={updateSettingCustomColor}
                    clearGetSettingColor={clearGetSettingColor}
                    clearUpdateSettingColor={clearUpdateSettingColor}
                    customColor={customColor}
                    updateCustomColor={updateCustomColor}
                />
            )}
            {currentTab === 1 && (
                <SettingCustomName
                    getSettingCustomText={getSettingCustomText}
                    clearGetSettingCustomText={clearGetSettingCustomText}
                    updateSettingCustomText={updateSettingCustomText}
                    clearUpdateSettingCustomText={clearUpdateSettingCustomText}
                    customText={customText}
                    updateCustomText={updateCustomText}
                    eventInfo={eventInfo}
                />
            )}
            {currentTab === 2 && (
                <SettingCustomOther
                    getSettingCustomComment={getSettingCustomComment}
                    clearGetSettingCustomComment={clearGetSettingCustomComment}
                    updateSettingCustomComment={updateSettingCustomComment}
                    clearUpdateSettingCustomComment={clearUpdateSettingCustomComment}
                    customComment={customComment}
                    updateCustomComment={updateCustomComment}
                    updateStatusComment={updateStatusComment}
                    eventInfo={eventInfo}
                />
            )}
            {currentTab === 3 && (
                <SettingCustomTimerCTRL
                    getSettingCustomTimerctrl={getSettingCustomTimerctrl}
                    clearGetSettingCustomTimerctrl={clearGetSettingCustomTimerctrl}
                    updateSettingCustomTimerctrl={updateSettingCustomTimerctrl}
                    clearUpdateSettingCustomTimerctrl={clearUpdateSettingCustomTimerctrl}
                    customTimerctrl={customTimerctrl}
                    updateCustomTimerctrl={updateCustomTimerctrl}
                    updateStatusTimerctrl={updateStatusTimerctrl}
                    eventInfo={eventInfo}
                />
            )}

        </>
    );
};

SettingCustom.defaultProps = {
    getSettingCustomColor: () => {},
    updateSettingCustomColor: () => {},
    clearGetSettingColor: () => {},
    clearUpdateSettingColor: () => {},
    isLoading: false,
    customColor: {},
    updateCustomColor: {},
    getSettingCustomText: () => {},
    clearGetSettingCustomText: () => {},
    updateSettingCustomText: () => {},
    clearUpdateSettingCustomText: () => {},
    customText: {},
    updateCustomText: {},
    getSettingCustomComment: () => {},
    clearGetSettingCustomComment: () => {},
    updateSettingCustomComment: () => {},
    clearUpdateSettingCustomComment: () => {},
    customComment: {},
    updateCustomComment: {},
    updateStatusComment: false,

    getSettingCustomTimerctrl: () => {},
    clearGetSettingCustomTimerctrl: () => {},
    updateSettingCustomTimerctrl: () => {},
    clearUpdateSettingCustomTimerctrl: () => {},
    customTimerctrl: {},
    updateCustomTimerctrl: {},
    updateStatusTimerctrl: false,

    eventInfo: {},
};

SettingCustom.propTypes = {
    getSettingCustomColor: PropTypes.func,
    updateSettingCustomColor: PropTypes.func,
    clearGetSettingColor: PropTypes.func,
    clearUpdateSettingColor: PropTypes.func,
    isLoading: PropTypes.bool,
    customColor: PropTypes.oneOfType([() => null, PropTypes.object]),
    updateCustomColor: PropTypes.oneOfType([() => null, PropTypes]),
    getSettingCustomText: PropTypes.func,
    clearGetSettingCustomText: PropTypes.func,
    updateSettingCustomText: PropTypes.func,
    clearUpdateSettingCustomText: PropTypes.func,
    customText: PropTypes.oneOfType([() => null, PropTypes.object]),
    updateCustomText: PropTypes.oneOfType([() => null, PropTypes.object]),
    getSettingCustomComment: PropTypes.func,
    clearGetSettingCustomComment: PropTypes.func,
    updateSettingCustomComment: PropTypes.func,
    clearUpdateSettingCustomComment: PropTypes.func,
    customComment: PropTypes.oneOfType([() => null, PropTypes.object]),
    updateCustomComment: PropTypes.oneOfType([() => null, PropTypes.object]),
    updateStatusComment: PropTypes.bool,

    getSettingCustomTimerctrl: PropTypes.func,
    clearGetSettingCustomTimerctrl: PropTypes.func,
    updateSettingCustomTimerctrl: PropTypes.func,
    clearUpdateSettingCustomTimerctrl: PropTypes.func,
    customTimerctrl: PropTypes.oneOfType([() => null, PropTypes.object]),
    updateCustomTimerctrl: PropTypes.oneOfType([() => null, PropTypes.object]),
    updateStatusTimerctrl: PropTypes.bool,

    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
};

export default SettingCustom;
